import * as React from "react";

const SvgMainMenuButton = (props) => (
  <svg
    width={25}
    height={25}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.875 7.5H3.125a.625.625 0 0 1 0-1.25h18.75a.625.625 0 0 1 0 1.25ZM21.875 13.75H3.125a.625.625 0 0 1 0-1.25h18.75a.625.625 0 0 1 0 1.25ZM21.875 20H3.125a.625.625 0 0 1 0-1.25h18.75a.625.625 0 0 1 0 1.25Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgMainMenuButton;
